<div class="rv-wrap" *ngIf="items.length > 0">

  <div class="rv-header">
    <span class="rv-title">
      <i class="bi bi-clock-history"></i>
      Recently Viewed
    </span>
    <button class="rv-clear-btn" (click)="clearAll($event)" title="Clear history">
      Clear
    </button>
  </div>

  <div class="rv-list">
    <a *ngFor="let item of items"
       class="rv-chip"
       [routerLink]="getPath(item.url)"
       [queryParams]="getQueryParams(item.url)"
       [title]="item.label">
      <span class="rv-chip__icon-wrap rv-chip__icon-wrap--{{ item.colorKey }}">
        <img *ngIf="item.iconUrl" [src]="item.iconUrl" alt="" class="rv-chip__client-icon" />
        <i *ngIf="!item.iconUrl" class="bi bi-{{ item.icon }}"></i>
      </span>
      <span class="rv-chip__body">
        <span class="rv-chip__label">{{ item.label }}</span>
        <span class="rv-chip__time">
          <span *ngIf="item.subtitle" class="rv-chip__subtitle">{{ item.subtitle }} · </span>{{ timeAgo(item.timestamp) }}
        </span>
      </span>
    </a>
  </div>

</div>
